import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../component/Loader";

const ReadmissionResponse = () => {
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    setIsRedirecting(true);

    // ePay usually returns params in the hash/query after redirect
    const params = new URLSearchParams(window.location.hash.split("?")[1]);

    const transaction_id = params.get("txnid");
    const semester = params.get("semester");


    // Save only what we need
    localStorage.setItem("transaction_id", transaction_id || "");
    localStorage.setItem("semester", semester || "");
    console.log({transaction_id})
    console.log({semester})




    if (transaction_id && semester) {
      // ✅ valid → redirect to condonation success/summary page
      setTimeout(() => {
        const baseUrl = window.location.origin;
        const newUrl = baseUrl + "/#/readmissionPayment";
        window.location.href = newUrl;
      }, 1000);
    } else {
      // ❌ invalid response → redirect back to condonation form
      localStorage.setItem("readmisison error", "Payment validation failed");
      const baseUrl = window.location.origin;
      const newUrl = baseUrl + "/#/studentreadmission";
      window.location.href = newUrl;
    }
  }, [navigate]);

  return isRedirecting;
};

export default function StudentReadmissionResponse() {
  const isRedirecting = ReadmissionResponse();

  return isRedirecting ? <Loader /> : null;
}
